import validateForm from '../../components/Form/validateForm';

// VIP Sign Up Form
export default function () {
  document.addEventListener('submit', (e) => {
    const target = e.target;
    if (target.matches('[data-vip-signup-form]')) {
      const form_success = validateForm(target, e);

      if (form_success) {
        target.closest('[data-vip-signup-form-container]').classList.add('submitted');

        target.parentElement.parentElement.querySelector('[data-vip-signup-success]').classList.add('submitted');
      }
    }
  });

  document.addEventListener('keyup', (e) => {
    const target = e.target;
    if (target.closest('[data-vip-signup-form]')) {
      validateForm(target.closest('[data-vip-signup-form]'));
    }
  });

  document.addEventListener('change', (e) => {
    const target = e.target;
    if (target.closest('[data-vip-signup-form]')) {
      validateForm(target.closest('[data-vip-signup-form]'));
    }
  });
}
